import { render } from "./FilterCarSvg.vue?vue&type=template&id=54668222"
import script from "./FilterCarSvg.vue?vue&type=script&lang=js"
export * from "./FilterCarSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__